export const loaded = {};
export const loadPromises = {};
